import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { HowItWorks } from "../components/site/HowItWorks";
import { Features } from "../components/site/Features";
import { ComingSoon } from "../components/site/ComingSoon";
import { Testimonials } from "../components/site/Testimonials";
import { FAQ } from "../components/site/FAQ";
import { Pricing } from "../components/site/Pricing";
import { InquiryForm } from "../components/site/InquiryForm";
import { Footer } from "../components/site/Footer";
import { WhatsAppButton } from "../components/site/WhatsAppButton";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [hash]);

  return (
    <div data-testid="home-page" className="min-h-screen bg-stone-50">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <ComingSoon />
        <Testimonials />
        <Pricing />
        <FAQ />
        <InquiryForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

